import React from 'react'
import { Container, Nav, ProgressBar, Row } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'

import * as routes from '../../routes'
import { isTabletOrMobileQuery } from '../../utils'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const StageIndicator = () => {
  const { pathname } = useLocation()
  const decodedPathname = decodeURIComponent(pathname);
  const { successfulResponse } = useSelector((state: RootState) => state.misc)
  const stageIdx = routes.stages.findIndex(
    stageDef => stageDef.path === decodedPathname,
  ) as number
  if (useMediaQuery(isTabletOrMobileQuery)) {
    const stage = routes.stages[stageIdx]
    if (stage !== undefined) {
      return (
        <Nav
          fill
          variant='pills'
          activeKey={pathname}
          className='bg-light'
          role='status'
        >
          <Container>
            <Row>
              <Nav.Item key={stage.path} className='p-2'>
                <Nav.Link
                  eventKey={stage.path}
                  onClick={(e:any) => {
                    e.preventDefault();
                  }}
                  className={
                    stageIdx !== routes.stages.length - 1
                      ? 'bg-info text-dark'
                      : successfulResponse?.submitted
                        ? 'dark-success'
                        : 'bg-danger'
                  }
                  aria-current={
                    stageIdx !== routes.stages.length - 1 ? 'step' : false
                  }
                >
                  {stageIdx + 1}. {stage.name}
                </Nav.Link>
              </Nav.Item>
            </Row>
          </Container>
        </Nav>
      )
    } else {
      return <></>
    }
  } else {
    const visibleStages = routes.stages
      // Label stages with the original index as it is required later
      // after the actual index in the list-view gets changed.
      .map((stage, idx) => ({ idx, ...stage }))
      // Filter out three sensible stages to actually show:
      .filter(
        stage =>
          // 1. on first stage => show first three stages
          (stageIdx === 0 && stage.idx >= 0 && stage.idx <= 2) ||
          // 2. on last stage => show last three stages
          (stageIdx === routes.stages.length - 1 &&
            stage.idx >= routes.stages.length - 3 &&
            stage.idx <= routes.stages.length - 1) ||
          // 3. on any other stage => show previous, current, and next stage
          (stageIdx - 1 <= stage.idx && stage.idx <= stageIdx + 1),
      )
      // Build actual navigation pills
      .map(stage => (
        <Nav.Item key={stage.path} className='p-2'>
          <Nav.Link
            eventKey={stage.path}
            onClick={(e:any) => {
              e.preventDefault();
            }}
            disabled={stageIdx !== stage.idx}
            className={
              stageIdx === stage.idx
                ? stageIdx !== routes.stages.length - 1
                  ? 'bg-info text-dark'
                  : successfulResponse?.submitted
                    ? 'dark-success'
                    : 'bg-danger'
                : undefined
            }
            aria-current={stageIdx === stage.idx ? 'step' : false}
          >
            {stage.name}
          </Nav.Link>
        </Nav.Item>
      ))
      // inject separator elements
      .reduce((acc, stage) => (
        <>
          {acc}
          <FontAwesomeIcon
            icon='chevron-right'
            className='mx-4 text-muted'
            aria-label='Hat nächsten Schritt'
          />
          {stage}
        </>
      ))
    return (
      <>
        <Nav fill variant='pills' activeKey={pathname} role='status'>
          <Container>
            <Row className='d-flex flex-row justify-content-between align-items-center'>
              {visibleStages}
            </Row>
            <Row>
              <Nav.Item className={"px-2"}>
                <ProgressBar
                  min={0}
                  max={routes.stages.length - 1}
                  now={stageIdx}
                  striped
                  animated
                  aria-label='Fortschrittsbalken der Anmeldung'
                  className='mb-3'
                  variant={
                    stageIdx !== routes.stages.length - 1
                      ? undefined
                      : successfulResponse?.submitted
                        ? 'success'
                        : 'danger'
                  }
                />
              </Nav.Item>
            </Row>
          </Container>
        </Nav>
      </>
    )
  }
}

export default StageIndicator
